import { Badge } from '@components/badge';

import { TravellerJourneyListItem } from 'api/types';

import { statusTagMap, statusLabelMap } from '../constants';

export const StatusCell = ({ row: traveller }: { row: TravellerJourneyListItem }) => {
  return <Badge variant={statusTagMap[traveller.status]} text={statusLabelMap[traveller.status]} />;
};
